import Table from 'react-bootstrap/Table';
import ImportAssets from '../features/importAssets/ImportAssets';
import '../styles/Table.css';
import { dateMonthYear } from '../utils/helper';
import { highPriorityIcon, inProgressIcon, lowPriorityIcon, mediumPriorityIcon, pendingIcon, resolvedIcon, scheduledIcon, unscheduledIcon } from '../utils/svgs';

const TableComponent = ({ icon, heading, columns, data, innerHeadingClass = '',
    className = '', showAddBtn = false, csvType, extraClass = '', onImportSuccess,
    anchorText = '', currentPage, showViewAll = false, onAnchorClick = null }) => {

    return (
        <>
            <div className={`table_heading ${innerHeadingClass}`}>
                <div className={className}>
                    {icon} {heading}
                </div>

                {
                    showAddBtn &&
                    <div>
                        <ImportAssets csvType={csvType} onImportSuccess={onImportSuccess} />
                    </div>
                }

                {
                    anchorText?.length > 0 &&
                    <div className="table_anchor_text" onClick={onAnchorClick}>
                        {anchorText}
                    </div>
                }
            </div>
            <Table responsive bordered className={extraClass}>
                <thead>
                    <tr>
                        {
                            columns.map((c, i) => (
                                <th key={i}>{c.label}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>

                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {
                                        column.value === 'scheduled_maintenance_date' || column.value === 'last_visit_date' || column.value === 'last_maintenance_date' ?
                                            dateMonthYear(row[column.value]) : column?.value === "vehicle.registration_number" ? row?.vehicle?.registration_number :
                                                column?.value === "vehicle.vehicle_brand" ? row?.vehicle?.vehicle_brand?.title || '-' :
                                                    column?.value === "vendor.name" ? row?.vendor?.name || '-' :
                                                        column?.value === "services_type" ?
                                                            <div className={`${row?.services_type}`} style={{ justifyContent: "center", padding: "5px 9px" }}>
                                                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                                                    {row?.services_type === 'scheduled' ? scheduledIcon : unscheduledIcon}
                                                                    {row?.services_type}
                                                                </div>
                                                            </div>
                                                            :
                                                            column?.value === "priority" ?
                                                                <div className={`priority ${row?.priority}`}>
                                                                    <div className='d-flex align-items-center justify-content-center gap-1'>
                                                                        {row?.priority === 'low' ? lowPriorityIcon : row?.priority === 'medium' ? mediumPriorityIcon : row?.priority === 'high' ? highPriorityIcon : null}
                                                                        {row?.priority}
                                                                    </div>
                                                                </div>
                                                                :
                                                                column?.value === "status" ?
                                                                    <div className={`status ${row?.status}`} style={{ justifyContent: "center", padding: "5px 9px", textTransform: "capitalize" }}>
                                                                        <div className='d-flex align-items-center justify-content-center gap-1'>
                                                                            {row?.status === "pending" ? pendingIcon : row?.status === "completed" ? resolvedIcon : row?.status === "in_progress" ? inProgressIcon : null}
                                                                            {row?.status === "in_progress" ? "In Progress" : row?.status}
                                                                        </div>
                                                                    </div> :

                                                                    column?.value === "service_short_info.service_id" ?
                                                                        row?.service_short_info?.service_id || '-'
                                                                        :

                                                                        column?.value === "service_short_info.status" ?
                                                                            <div className={`status ${row?.service_short_info?.status}`} style={{ justifyContent: "center", padding: "5px 9px", textTransform: "capitalize" }}>
                                                                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                                                                    {row?.service_short_info?.status === "pending" ? pendingIcon : row?.service_short_info?.status === "completed" ? resolvedIcon : row?.service_short_info?.status === "in_progress" ? inProgressIcon : null}
                                                                                    {row?.service_short_info?.status === "in_progress" ? "In Progress" : row?.service_short_info?.status}
                                                                                </div>
                                                                            </div> :
                                                                        column?.value === "service_short_info.complete_at" ?
                                    dateMonthYear(row?.service_short_info?.complete_at) || '-' :
                                    row[column.value] || '-'
                                    }
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
            {
                data?.length === 0 &&
                <h6 style={{ textAlign: "center", marginBottom: "30px", fontSize: "20px", marginTop: "20px", textTransform: "capitalize" }}>{data?.length === 0 && "No data found"}</h6>
            }
        </>
    )
}
export default TableComponent